import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './util';

// * Note: I made it a separate service so that the code
// * isn't all crammed into the patient service file.

export class ActionService extends BaseService {
  static async getStatusCount () {
    try {
      const response = await this.request({ auth: true, v2: true }).get(
        '/admin/patientDashboard/counts'
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getActionNote (id) {
    try {
      const response = await this.request({ auth: true, v2: true }).get(
        `/admin/patient/${id}/actionnotes`
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async addActionNote (id, body) {
    try {
      // ? Accepted actionids:
      // * failedtransaction
      // * needspatientreply
      // * followupcompletion
      // * fullycancelled
      // * active
      const response = await this.request({ auth: true, v2: true }).post(
        `/admin/patient/${id}/actionnotes`,
        body
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async dequeueItem (id, tab, forwardedMessageId) {
    try {
      const response = await this.request({ auth: true, v2: true }).post(
        `/admin/dashboardExclude/patient/${id}/${tab}`,
        null,
        {
          params: {
            forwardedmessageid: forwardedMessageId
          }
        }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async dequeueType (id, type) {
    try {
      const response = await this.request({ auth: true, v2: true }).post(
        `/admin/dashboardExclude/prescriptionOrder/${id}/${type}`
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
